function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  fill: "currentColor",
  height: "1em",
  width: "1em",
  viewBox: "64 64 896 896"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M344.05 50v369.35L800 50v900L344.05 580.625V950H175V50h169.05z"
}));